import { useTranslation } from "react-i18next";
import { Building2, Package, Activity, ReceiptText, Truck, Send, Shuffle, ClipboardCheck } from "lucide-react";

const TABS = [
  { key: "warehouses", icon: Building2 },
  { key: "balances", icon: Package },
  { key: "movements", icon: Activity },
  { key: "receipts", icon: ReceiptText },
  { key: "incoming", icon: Truck },
  { key: "issues", icon: Send },
  { key: "transfers", icon: Shuffle },
  { key: "counts", icon: ClipboardCheck },
];

// شريط تبويبات ثابت لقسم المخازن — أيقونات كبيرة وعناوين واضحة.
export const WhTabs = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-8" data-testid="wh-tabs">
      {TABS.map(({ key, icon: Icon }) => (
        <button key={key} type="button" data-testid={`wh-tab-${key}`} onClick={() => onChange(key)}
                className={`flex items-center justify-center gap-2 rounded-2xl px-3 py-3 text-xs font-bold transition ${
                  value === key ? "bg-primary/15 text-primary shadow-neu-in"
                                : "shadow-neu-sm hover:shadow-neu-md"}`}>
          <Icon className="h-4 w-4" /> <span>{t(`warehouse.tabs.${key}`)}</span>
        </button>
      ))}
    </div>
  );
};
